// SPDX-FileCopyrightText: OpenTalk GmbH <mail@opentalk.eu>
// SPDX-License-Identifier: EUPL-1.2
import ParticipantAvatar from './ParticipantAvatar';

export { setLibravatarOptions } from './ParticipantAvatar';
export default ParticipantAvatar;
